import React, { useState, useEffect } from "react";
import {
  Space,
  Row,
  Col,
  Switch,
  Form,
  Button,
  message,
  Skeleton,
  Divider
} from "antd";
import ClassInputs from "../inputs/class";
import { gql, useMutation, useLazyQuery } from "@apollo/client";
import DeleteCoreProduct from "@general/deleteCoreProduct";
import moment from "moment-jalaali";

const UPDATECLASS = gql`
  mutation updateClass(
    $updateClassInput: UpdateClassInput!
    $id: ID!
  ) {
    updateClass(updateClassInput: $updateClassInput, id: $id)
  }
`;

const GETPRODUCT = gql`
  query ($id: ID!) {
    getProduct(id: $id) {
      createdAt
      updatedAt
      name
      description
      strikethroughRial
      amountRial
      capacity
      image
    }
  }
`;

function ClassDetails({ id, onDataUpdate }) {
  const [form] = Form.useForm();
  const [error, setError] = useState(null);
  const [editable, setEditable] = useState(false);
  const [initialData, setInitialData] = useState({});

  const [runUpdateClass, updateClass] = useMutation(UPDATECLASS, {
    onCompleted() {
      message.success("خدمت بروزرسانی شد.");
      onDataUpdate();
    },
    onError(err) {
      console.log("خطا: " + err.message);
      message.error("مشکلی پیش آمده! خدمت بروزرسانی نشد.");
    },
  });

  const doUpdateData = (updateClassInput) => {
    runUpdateClass({
      variables: {
        id,
        updateClassInput
      },
    });
  };
  const [getServiceData, serviceData] = useLazyQuery(GETPRODUCT, {
    fetchPolicy: "no-cache",
    onCompleted({ getProduct }) {
      const { createdAt, updatedAt, name, description,  strikethroughRial,
        amountRial,
        capacity,
        image } = getProduct;
      const serviceData = {
        name,
        description,
        strikethroughRial,
        amountRial,
        capacity,
        image
      };
      form.setFieldsValue(serviceData);
      setInitialData({
        createdAt: createdAt && moment(createdAt).format("jYYYY/jMM/jDD"),
        updatedAt: updatedAt && moment(updatedAt).format("jYYYY/jMM/jDD"),
      });
    },
  });
  useEffect(() => {
    if (id) {
      getServiceData({
        variables: {
          id,
        },
      });
    }
    setEditable(false);
  }, [id]);
  const { createdAt, updatedAt } = initialData;
  if (serviceData.loading)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );
  return (
    <div>
      <Row>
        <Col sm={12} xs={24}>
          <Space align="">
            <p>تاریخ ثبت: </p>
            {createdAt}
          </Space>
        </Col>
        <Col sm={12} xs={24}>
          <Space align="">
            <p>آخرین بروزرسانی: </p>
            {updatedAt}
          </Space>
        </Col>
      </Row>
 <Divider />
      <Row>
        <Space align>
          <p>ویرایش: </p>
          <Switch onChange={() => setEditable(!editable)} />
        </Space>
      </Row>
     
      <Form
        layout="vertical"
        onFinish={doUpdateData}
        form={form}
        disabled={!editable}
      >
        <Row gutter={15}>
          <Col xs={24} lg={24}>
            <ClassInputs
              error={error}
            />
          </Col>
        </Row>
        <Space>
          <Button
            type="primary"
            htmlType="submit"
            loading={updateClass.loading && true}
          >
            بروزرسانی
          </Button>
          <DeleteCoreProduct
            id={id}
            onDeleteCoreProduct={onDataUpdate}
            error={error}
          >
            <Button danger>حذف</Button>
          </DeleteCoreProduct>
        </Space>
      </Form>
    </div>
  );
}

export default ClassDetails;
